import { defaultSchema } from 'rehype-sanitize';

/** Sanitize schema for the assistant markdown pipeline. */
export const sanitizeSchema = defaultSchema;
